import { CommonModule } from '@angular/common';
import {
  Attribute,
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';

@Component({
  selector: 'sh-button',
  template: `
    <button ejs-button [ngClass]="class" [disabled]="disabled">
      <ng-content></ng-content>
    </button>
  `,
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, CommonModule],
})
export class ButtonComponent {
  @Input() disabled = false;

  get class() {
    return this.link != null ? 'e-link' : '';
  }

  @HostBinding('class')
  _type = !this.type || this.type === 'submit' ? 'submit' : 'button';

  constructor(
    @Attribute('link') public link: string | null,
    @Attribute('type') public type: string | null
  ) {}
}
